import classnames from 'classnames';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export function ClientName({
  className,
  children,
}: {
  className?: string;
  children?: string;
}) {
  return (
    <span className={classnames(className, !children && 'italic')}>
      {children || 'Unidentified clients'}
    </span>
  );
}

export function ClientVersion({
  className,
  children,
}: {
  className?: string;
  children?: string;
}) {
  return (
    <span className={classnames(className, !children && 'italic')}>
      {children || 'Unspecified version'}
    </span>
  );
}

export function ClientVersionList({
  className,
  clientName,
  versions,
}: {
  className?: string;
  clientName: string;
  versions: readonly string[];
}) {
  return (
    <Tooltip
      label={
        <>
          <div className="mb-4">
            All client versions for{' '}
            <ClientName className="font-semibold">{clientName}</ClientName>
          </div>
          <div className="max-h-48 overflow-auto">
            {versions.map((clientVersion) => (
              <p key={clientVersion}>
                <ClientVersion>{clientVersion}</ClientVersion>
              </p>
            ))}
          </div>
        </>
      }
      interactive
    >
      <span className={className}>
        {versions.slice(0, 3).map((clientVersion, idx, a) => (
          <React.Fragment key={`${clientVersion}`}>
            <ClientVersion>
              {clientVersion.length > 6
                ? clientVersion.substr(0, 6).concat('...')
                : clientVersion}
            </ClientVersion>
            {idx !== a.length - 1 ? ', ' : ''}
          </React.Fragment>
        ))}
        {versions.length > 3 ? ` + ${versions.length - 3} more` : ''}
      </span>
    </Tooltip>
  );
}
